import type { SkeletonLoaderProps } from '@kanda-libs/ks-design-library';

export const BASE_SKELETON_PROPS: SkeletonLoaderProps = {
  width: 60,
  height: 20,
};
